module.exports = function() {
  return new Worker(__webpack_public_path__ + "83703ffb86df3537e125.worker.js");
};